import { Model } from 'pinia-orm';
import Job from './Job';

export default class Attachment extends Model {

    static get entity () {
        return 'attachments'
    }

    static fields () {
        return {
            id: this.uid(),
            title: this.attr(''),
            active: this.attr(false),
            job_id: this.attr(null),
            filename: this.attr(''),
            original_name: this.attr(''),
            locale: this.attr(''),
            extension: this.attr(''),
            url: this.attr(''),
            job: this.belongsTo(Job, 'job_id'),
        }
    }
}
